import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from 'dashboard/store/mutation-types';
import ConversationResolutionSubjectAPI from 'custom/dashboard/api/conversationResolutionSubject';

export const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

export const getters = {
  getConversationResolutionSubjects($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  getConversationResolutionSubject: async function fetchSubjects({ commit }) {
    commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG, {
      fetchingList: true,
    });
    try {
      const response = await ConversationResolutionSubjectAPI.get();
      commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT, response.data);
    } finally {
      commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  createConversationResolutionSubject: async function createSubject(
    { commit },
    payload
  ) {
    commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG, {
      creatingItem: true,
    });
    try {
      const response = await ConversationResolutionSubjectAPI.create({
        conversation_resolution_subject: payload,
      });
      commit(types.default.ADD_CONVERSATION_RESOLUTION_SUBJECT, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  updateConversationResolutionSubject: async function updateSubject(
    { commit },
    { id, ...payload }
  ) {
    commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG, {
      updatingItem: true,
    });
    try {
      const response = await ConversationResolutionSubjectAPI.update(id, {
        conversation_resolution_subject: payload,
      });
      commit(types.default.EDIT_CONVERSATION_RESOLUTION_SUBJECT, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  deleteConversationResolutionSubject: async function deleteSubject(
    { commit },
    id
  ) {
    commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG, {
      deletingItem: true,
    });
    try {
      await ConversationResolutionSubjectAPI.delete(id);
      commit(types.default.DELETE_CONVERSATION_RESOLUTION_SUBJECT, id);
      return id;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG, {
        deletingItem: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_CONVERSATION_RESOLUTION_SUBJECT_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.default.SET_CONVERSATION_RESOLUTION_SUBJECT]: MutationHelpers.set,
  [types.default.ADD_CONVERSATION_RESOLUTION_SUBJECT]: MutationHelpers.create,
  [types.default.EDIT_CONVERSATION_RESOLUTION_SUBJECT]: MutationHelpers.update,
  [types.default.DELETE_CONVERSATION_RESOLUTION_SUBJECT]:
    MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
